import React from 'react';
import moment from 'moment-timezone';
import difference from 'lodash/difference';

import {calculateAvailabileDays, getDays} from '../../helpers/scheduling';
import DayPicker from '../common/DayPicker';

const ScheduleDayPicker = ({date, availabilities, ...props}) => {
  const availableDays = (
    availabilities?.length 
    ? calculateAvailabileDays({
      date,
      availabilities,
      timezone: (
        availabilities?.length
        ? availabilities?.[0]?.provider?.timezone
        : moment.tz.guess()
      ),
    })
    : []
  );
  const disabledDays = difference(getDays(), availableDays);
  const childProps = {
    ...props,
    date,
    disabledDays,
  };
  return <DayPicker {...childProps} />;
};

export default ScheduleDayPicker;